'use client';

import { SearchBar, SearchResults } from '@/features/search';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { Suspense } from 'react';
import { useDebouncedCallback } from 'use-debounce';

export const SearchController = () => {
  // store the search query in the URL, so that the user can bookmark or share the URL
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const { replace } = useRouter();

  const onSearchChange = useDebouncedCallback((search: string) => {
    if (!searchParams) return;
    const params = new URLSearchParams(searchParams);
    if (search) {
      params.set('query', search);
    } else {
      params.delete('query');
    }
    replace(`${pathname}?${params.toString()}`);
  }, 300);

  if (!searchParams) return;
  return (
    <div className="min-h-[600px]">
      <Suspense>
        <div className="px-e4 mx-auto mt-24 max-w-7xl sm:px-10 lg:mb-20 lg:mt-48 lg:px-48">
          <SearchBar onSearchChange={onSearchChange} />
        </div>
      </Suspense>
      <Suspense>
        <SearchResults query={searchParams.get('query')?.toString()} />
      </Suspense>
    </div>
  );
};
